import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=6245f774"
import script from "./homePage.vue?vue&type=script&lang=js"
export * from "./homePage.vue?vue&type=script&lang=js"
import style0 from "./homePage.vue?vue&type=style&index=0&id=6245f774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports